import React, { useState } from 'react';
import { Container, Badge } from 'react-bootstrap';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import policyAiLogo from '../assets/policy-ai-logo.svg';

const Header = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { isLoggedIn, isAdmin, user, logout } = useAuth();
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="header">
      <Container>
        <div className="header-content">
          <div className="header-brand">
            <img src={policyAiLogo} alt="" className="app-logo" aria-hidden="true" />
            <h1>Policy and Procedures Assistant</h1>
          </div>
          <div className="d-flex align-items-center gap-2">
          <button
            className="dark-mode-toggle"
            onClick={toggleDarkMode}
          >
            <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'} me-2`}></i>
            <span className="header-btn-label">{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>
          </button>

          {isLoggedIn ? (
            <div className="d-flex align-items-center gap-2">
              <span className="text-white small">
                <i className="fas fa-user me-1"></i>
                {user.username}
              </span>
              {isAdmin && (
                <Badge bg="warning" text="dark">
                  <i className="fas fa-shield-alt me-1"></i>Admin
                </Badge>
              )}
              <button className="dark-mode-toggle" onClick={logout}>
                <i className="fas fa-sign-out-alt me-2"></i>
                <span className="header-btn-label">Logout</span>
              </button>
            </div>
          ) : (
            <button className="dark-mode-toggle" onClick={() => setShowLogin(true)}>
              <i className="fas fa-sign-in-alt me-2"></i>
              <span className="header-btn-label">Login</span>
            </button>
          )}
        </div>
        </div>
      </Container>

      <LoginModal show={showLogin} onHide={() => setShowLogin(false)} />
    </div>
  );
};

export default Header;

